module.exports = __webpack_public_path__ + "img/ydd_code.d81bafab.png";